<template>
    <div id="patients-portal-form">
        <div class="page-height">
            <b-row>
                <b-col class="col-12">
                    <MdTitleRegInfo
                        v-bind:RegistrationInfo="PatientTitle"
                        v-bind:titlePrefix="$t('PPDbForm.Title')"
                        v-bind:titleRef="'titleElementPatientNotes'"
                        v-bind:patientCode="patientCode"
                    >
                    </MdTitleRegInfo>

                    <div
                        class="alert alert-fill-warning d-flex align-items-center m-3"
                        role="alert"
                        v-if="isReadOnly"
                    >
                        <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                        <div class="flex-grow-1">
                            <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdButton
                        v-bind:Label="$t('PPDbForm.AddForm')"
                        v-bind:ClassProp="
                            this.isReadOnly
                                ? 'btn btn-primary my-3 btn-block'
                                : 'btn btn-primary my-3 btn-block btn-login'
                        "
                        v-bind:IconClass="'ti-plus pr-1'"
                        v-on:click="addNoteToPatient"
                        v-bind:isReadOnly="this.isReadOnly"
                        v-bind:Name="'btn_add_note'"
                    >
                    </MdButton>
                </b-col>
                <b-col lg="6" sm="6" md="6">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input
                                type="text"
                                class="form-control"
                                :dir="dirInput"
                                v-model="parameters.searchCriteria"
                                @keyup.enter="searchNotes"
                            />
                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="searchNotes"
                                >
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col lg="3" sm="3" md="3">
                    <MdSelect
                        v-bind:Label="$t('Shared.Status')"
                        v-bind:Options="noteStatusOptions"
                        v-bind:ModelArray="noteStatusModel"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'value'"
                        v-bind:Multiple="false"
                        v-bind:IfUsevalidation="false"
                        :Input="changeDropDownNoteStatus"
                        v-bind:Name="'note_status_select'"
                        id="note_status_select"
                    />
                </b-col>
            </b-row>

            <MdTitle
                v-bind:Text="$t('Shared.SearchResult')"
                v-bind:isSubtitle="true"
                v-bind:Name="'T_TitleSearch'"
            />

            <b-row>
                <b-col class="col-12 mt-2">
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="showMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:VisibleEditIcon="false"
                        v-bind:FieldsDate="fieldsDateArr"
                        :pageChanged="pageChanged"
                        :perPageFunction="perPageFunction"
                        :deleteIconEvent="removeNote"
                        v-bind:VisibleDeleteIcon="!isReadOnly"
                        v-bind:IsPatientPortalForm="true"
                        :isReadOnly="isReadOnly"
                    >
                    </MdTable>
                </b-col>
            </b-row>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnpatientlist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="gotoPatientPortal"
            />
        </div>

        <patient-portal-assign-note
            :visible.sync="assignNoteModalVisible"
            :patientCode="patientCode"
            @ok="saveNote"
        >
        </patient-portal-assign-note>

        <patient-portal-notify
            :visible.sync="notifyVisible"
            :patientCodeList="selectedPatientCodeList"
            :notifyType="notifyType"
            :notifyTemplateList="
                notifyType === 'email' ? notifyEmailTemplateList : notifyTextTemplateList
            "
        />
    </div>
</template>

<script>
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import EnumService from '@/services/enum.service';
import PatientPortalAssignedNoteService from '@/services/patientPortalAssignedNote.service';
import PatientPortalsService from '@/services/patientportals.service';
import { patientsPortalStore } from './patientsPortalStore';
import PatientsPortalBase from './patientsPortalBase.vue';
import PatientPortalAssignNote from './dialogs/patientPortalAssignNote.vue';
import PatientPortalNotify from './dialogs/patientPortalNotify.vue';

export default {
    name: 'PatientsPortalForm',
    extends: PatientsPortalBase,
    components: { PatientPortalAssignNote, PatientPortalNotify },
    data() {
        return {
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalSummaryItems)),
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'assignedDate',
                    sortable: true,
                    label: this.$t('PPDbForm.AssignedDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'description',
                    sortable: true,
                    label: this.$tc('Shared.Form', 1),
                    class: 'text-left'
                },
                {
                    key: 'expirationDate',
                    sortable: true,
                    label: this.$t('Shared.ExpirationDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                }
            ],
            fieldsDateArr: ['assignedDate', 'expirationDate'],
            showMessageIsEmpty: false,
            parameters: {
                searchCriteria: ''
            },
            noteStatusOptions: EnumService.PatientPortalNoteStatus,
            noteStatusModel: { value: 'New', name: this.$t('Shared.New') },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            patientCode: this.$route.params.id,
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            isReadOnly: this.$store.state.isPatientPortalFormsEHRReadOnly,
            assignNoteModalVisible: false
        };
    },
    methods: {
        gotoPatientPortal() {
            this.$router.push({ name: 'patients-portal' });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        searchNotes() {
            this.currentPage = 1;
            this.listingAsync();
        },

        changeDropDownNoteStatus(item) {
            this.noteStatusModel = item ? item : { value: null, name: this.$t('Shared.All') };
            this.searchNotes();
        },

        addNoteToPatient() {
            this.assignNoteModalVisible = true;
        },

        removeNote(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('PPDbForm.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_note'
                })
                .then(value => {
                    if (value) {
                        PatientPortalAssignedNoteService.delete(row.headerId)
                            .then(() => {
                                this.searchNotes();
                            })
                            .catch(error => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        async saveNote(data) {
            const parameters = {
                patientCode: this.patientCode,
                ...data
            };

            await PatientPortalAssignedNoteService.add(parameters)
                .then(response => {
                    if (response.status == '200') {
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('Shared.SavedSuccessfully'),
                            'success'
                        );

                        this.searchNotes();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async listingAsync() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                PatientCode: this.patientCode,
                ...this.parameters
            };

            if (this.noteStatusModel && this.noteStatusModel.value) {
                parameters.NoteStatus = this.noteStatusModel.value;
            }

            await PatientPortalAssignedNoteService.getAll(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async loadPatientTitle(patientCode) {
            const infoList = await this.getInfoTitle(patientCode);
            if (infoList && infoList.length > 0) {
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];
                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = `${firstname} ${lastname}`;
            }
        },

        async loadPortalPatient(patientCode) {
            const response = await PatientPortalsService.getAllDashboard({
                PageSize: 1,
                PageNumber: 1,
                PatientCodeList: [patientCode],
                status: null,
                portalStatus: null
            });
            if (response.status === 200 && response.data && response.data.length > 0) {
                this.selectedItems = response.data.filter(
                    x => x.patientCode.trim() === patientCode.trim()
                );
            }
        },

        enabledAllItems() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            this.RightMenuList.forEach(element => {
                let buttonEnabled = false;
                switch (element.value) {
                    case 'PPDB_CreateCredentials':
                        buttonEnabled =
                            item &&
                            item.portalStatus === 'Not Enrolled' &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email) &&
                            !!item.dob;
                        break;
                    case 'PPDB_ChangeUsername':
                    case 'PPDB_ChangePassword':
                        buttonEnabled = item && !Utils.isNullOrEmptyString(item.userName);
                        break;
                    case 'PPDB_PatientForms':
                    case 'PPDB_PatientContacts':
                    case 'PPDB_PatientClaims':
                    case 'PPDB_PatientInfo':
                    case 'PPDB_Summary':
                    case 'PPDB_ChangePatInfo':
                    case 'PPDB_Messages':
                    case 'PPDB_PatientList':
                        buttonEnabled = true;
                        break;
                    case 'PPDB_EmailToPatient':
                        buttonEnabled = this.isNotify('email');
                        break;
                    case 'PPDB_TextToPatient':
                        buttonEnabled = this.isNotify('text');
                        break;
                    default:
                        break;
                }
                element.ReadOnly = !buttonEnabled;
            });

            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
            this.OptionsRightMenu.ItemsList = this.RightMenuList;
            this.OptionsRightMenu.active_el = this.getActiveElement();
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        }
    },

    async mounted() {
        const patientCode = this.patientCode;

        if (patientCode) {
            await this.$nextTick();
            EventBus.$emit('loadMenu', patientCode);
            try {
                const stored = patientsPortalStore.selectedItem;
                if (stored && stored.patientCode.trim() === patientCode.trim()) {
                    this.selectedItems = [stored];
                    patientsPortalStore.selectedItem = null;
                    await this.loadPatientTitle(patientCode);
                } else {
                    await Promise.all([
                        this.loadPatientTitle(patientCode),
                        this.loadPortalPatient(patientCode)
                    ]);
                }
            } catch (e) {
                // fall through to enabledAllItems with whatever data loaded
            }
        }

        this.enabledAllItems();
        await this.listingAsync();
    }
};
</script>
